
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/addPreset/htmlPreviewThumbnail/htmlThumbnailDragBox.scss.css.virtualfile';
        module.exports = {"htmlThumbnailDragBox":"_htmlThumbnailDragBox_pf8vv_7"};